import React, { useState } from 'react';
import { 
    Box, AppBar, Toolbar, IconButton, Typography, Avatar, Menu, MenuItem, 
    ListItemIcon, ListItemText, Divider, Breadcrumbs, Link as MuiLink 
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

// آیکون‌ها
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleClose();
  };
  
  // !! اصلاح کلیدی: پیاده‌سازی منطق صحیح خروج !!
  const handleLogout = () => {
    fetch('/db/logout.php', { method: 'POST', credentials: 'include' })
      .then(response => {
        if (response.ok) {
          window.location.replace('/auth/login');
        } else {
          // در صورت بروز خطا در خروج، می‌توانید به کاربر اطلاع دهید
          console.error('Logout failed');
        }
      })
      .catch(error => {
        console.error('Error during logout:', error);
      });
    handleClose();
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  };

  // این مپ برای نمایش نام فارسی در مسیر راهنما استفاده می‌شود
  const breadcrumbNameMap = {
      'overview': 'آمار کلی',
      'products': 'محصولات',
      'orders': 'سفارشات',
      'customers': 'مشتریان',
      'settings': 'تنظیمات',
      'profile': 'پروفایل کاربری',
      'subscription': 'مدیریت اشتراک',
      'tutorial': 'آموزش'
  };
  const pathSegment = location.pathname.split('/').pop();


  return (
    <AppBar 
      position="static" 
      sx={{ 
        background: 'rgba(22, 34, 42, 0.5)',
        backdropFilter: 'blur(10px)',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Toolbar>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" sx={{color: 'rgba(255,255,255,0.5)'}} />} sx={{color: '#fff'}}>
            <MuiLink component="button" onClick={() => navigate('/projects')} sx={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', cursor: 'pointer', fontSize: '0.875rem'}}>پروژه‌ها</MuiLink>
            <Typography color="text.primary" sx={{color: '#fff', fontWeight: 'bold'}}>{breadcrumbNameMap[pathSegment] || 'داشبورد'}</Typography>
        </Breadcrumbs>
        
        <Box sx={{ flexGrow: 1 }} />
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton color="inherit" onClick={toggleFullscreen}>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>

            <IconButton color="inherit">
                <NotificationsNoneOutlinedIcon />
            </IconButton>

            <IconButton
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar 
                sx={{ 
                  width: 36, 
                  height: 36, 
                  bgcolor: '#61dafb', 
                  color: '#16222A', 
                  fontSize: '1rem',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                      transform: 'scale(1.1)',
                      boxShadow: '0 0 15px rgba(97, 218, 251, 0.7)'
                  }
                }}
              >
                H
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  background: 'rgba(33, 49, 63, 0.8)',
                  backdropFilter: 'blur(10px)',
                  color: '#fff',
                  borderRadius: '10px',
                  border: '1px solid rgba(255,255,255,0.1)',
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={() => handleNavigate('/project/profile')}>
                <ListItemIcon><PersonOutlineIcon fontSize="small" sx={{color: '#fff'}} /></ListItemIcon>
                <ListItemText>پروفایل کاربری</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleNavigate('/projects')}>
                <ListItemIcon><FolderOutlinedIcon fontSize="small" sx={{color: '#fff'}}/></ListItemIcon>
                <ListItemText>پروژه‌های من</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleNavigate('/project/subscription')}>
                <ListItemIcon><CreditCardOutlinedIcon fontSize="small" sx={{color: '#fff'}}/></ListItemIcon>
                <ListItemText>مدیریت اشتراک</ListItemText>
              </MenuItem>
               <MenuItem onClick={() => handleNavigate('/project/tutorial')}>
                <ListItemIcon><SchoolOutlinedIcon fontSize="small" sx={{color: '#fff'}}/></ListItemIcon>
                <ListItemText>آموزش</ListItemText>
              </MenuItem>
              <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.1)' }} />
              <MenuItem onClick={handleLogout} sx={{color: '#ff4d4d'}}>
                <ListItemIcon><LogoutOutlinedIcon fontSize="small" sx={{color: '#ff4d4d'}}/></ListItemIcon>
                <ListItemText>خروج از حساب</ListItemText>
              </MenuItem>
            </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;